export namespace Assets {
  export const images = {
    logo: "https://assets.iyk.app/krost/logo.jpg",
    noImageFallback: "https://assets.iyk.app/krost/no-image-fallback.png",
    onboarding: "https://assets.iyk.app/krost/onboarding-1.png",
    og: "https://assets.iyk.app/krost/og-image.png",
  }

  export const documents = {
    privacyPolicy: "https://assets.iyk.app/iyk-privacy-policy.pdf",
    termsOfService: "https://assets.iyk.app/iyk-terms-of-service.pdf",
  }
}
